import classNames from "classnames";
import React, {
    HTMLAttributes, ReactElement,
} from "react";
import Styles from "../Table.module.scss";

export type TableControlsSeparatorProps = HTMLAttributes<HTMLDivElement>

const TableControlsControl = React.forwardRef((
    args: TableControlsSeparatorProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactElement => {
    const {
        className,
        children,
        ...rest
    } = args;

    return (
        <div className={classNames(Styles.control, className)} ref={ref} {...rest}>
            {children}
        </div>
    );
});

export default TableControlsControl;
